import { debounce } from '@mui/material';
import { DateTime } from 'luxon';

export function getInviteDate({ date, hour }: { date: Date; hour: Date }) {
  const dateFormat = new Date(date.toISOString());
  dateFormat.setHours(hour.getHours());
  dateFormat.setMinutes(hour.getMinutes());

  const dateTimezoneFormated = DateTime.fromISO(dateFormat.toISOString(), {
    zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });

  return dateTimezoneFormated;
}

export const debounced =
  typeof jest === 'undefined'
    ? debounce((callback: () => void) => callback(), 500)
    : (callback: () => void) => callback();

export function isMinimumInviteTime(
  hourInvite: DateTime,
  minimumInviteTime: number,
) {
  const today = DateTime.now();

  const diference = hourInvite.diff(today, 'hours').toObject();

  return diference.hours && diference.hours < minimumInviteTime;
}
